module.exports = __webpack_public_path__ + "static/sec3-e51a1b7f9d70ae8fe7855c34ef7b0a99.png";